import DispatchIconSvg from '../Icons/DispatchIcon.svg';
import FleetTrackingIconSvg from '../Icons/FleetTrackingIcon.svg';
import FlightsIconSvg from '../Icons/FlightsIcon.svg';
import JraIcon from '../Icons/JraIcon.svg';
import MapIconSvg from '../Icons/MapIcon.svg';
import ImageryIconSvg from '../Icons/ImageryIcon.svg';
import MarketplaceIconSvg from '../Icons/MarketplaceIcon.svg';
import DocsIconSvg from '../Icons/DocIcon.svg';
import AircraftIconSvg from '../Icons/AircraftIcon.svg';
import LogbookIconSvg from '../Icons/LogbookIcon.svg';
import InsuranceIconSvg from '../Icons/InsuranceIcon.svg';
import DirectoryIconSvg from '../Icons/DirectoryIcon.svg';
import TrackLogsIconSvg from '../Icons/TrackLogsIcon.svg';
import CloudAhoyIconSvg from '../Icons/CloudAhoyIcon.svg';
import PeopleIconSvg from '../Icons/PeopleIcon.svg';
import ReservoirIconSvg from '../Icons/ReservoirIcon.svg';
import RosterIconSvg from '../Icons/RosterIcon.svg';
import DataDownloadsIconSvg from '../Icons/DataDownloadsIcon.svg';
import FlightServicesIconSvg from '../Icons/FlightServicesIcon.svg';
import OrgIconSvg from '../Icons/OrgIcon.svg';
import OrgSettingsIconSvg from '../Icons/OrgSettingsAppIcon.svg';
import IconSmartGroupsSvg from '../Icons/SmartGroups.svg';
import IconBillingSvg from '../Icons/IconBilling.svg';
import ManageDocsIconSvg from '../Icons/ManageDocsIcon.svg';
import JetFuelXIconSvg from '../Icons/JetFuelXIcon.svg';
import ChecklistIconSvg from '../Icons/ChecklistIcon.svg';
import AccountIconSvg from '../Icons/AccountIcon.svg';
import SupportIconSvg from '../Icons/SupportIcon.svg';
import LogoutIconSvg from '../Icons/LogoutIcon.svg';
import CustomContentIcon from '../Icons/CustomContentIcon.svg';
import HoneywellForgeIconSvg from '../Icons/HoneywellForgeIcon.svg';
import CelebrationIconSvg from '../Icons/CelebrationIcon.svg';
import GetHelpIconSvg from '../Icons/GetHelpIcon.svg';
import AirportDirectoryIcon from '../Icons/AirportDirectoryIcon.svg';
import FlightSchedulerIcon from '../Icons/FlightSchedulerIcon.svg';
import FleetIcon from '../Icons/FleetIcon.svg';
import FratShieldIcon from '../Icons/FratShieldCheckIcon.svg';
import TripPlannerIcon from '../Icons/TripPlannerIcon.svg';
import getStandaloneHost from 'ff/common/components/getStandaloneHost';
import {
    CurrentUser,
    hasEnterpriseDocuments,
    hasJeppesenDispatch,
    hasTripPlanner,
    hasSmartGroups,
    isFeatureEnabled,
    isOrgOwner,
    hasInsurance,
    hasDispatchTools,
    isAllTiers,
    isSubOrgAdmin,
    hasLicense,
    isGroupOwner,
    hasCustomContentMenuItem,
    hasFratLicense,
    hasSmsLicense,
    isOrgDocumentsAdmin,
    hasCATrackingLicense,
} from 'ff/common/system';
import { logClick } from 'ff/common/SegmentAnalytics';
import renderDivider from '../MenuItems/Divider';
import Chevron from '../Icons/cheveron.svg';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';
import createLogbookCTA from 'ff/common/components/FFMenuV2/MenuItems/LogbookCTA';
import isGovOrIl5EnvCommon from 'shared/sharedCode/isGovOrIl5EnvCommon';
import { isMenuItemHiddenForEnv } from 'ff/common/components/FFMenuV2/hiddenMenuItems';
import { GET_MENU_ORDER_LOCAL_STORAGE_KEY } from 'ff/common/components/FFMenuV2/AddItems/ReorderPersistence';

declare global {
    interface Window {
        activeMenu?: string;
    }
}

const host = getStandaloneHost() || '';

export const renderDispatch = (params: RenderMenuParams) => {
    //if we do the .bind pattern it will read window.serverEnv before renderMenu() has been called. This causes it
    // to not be set when loaded from dispatch qa, and so on dispatch qa the dispatch menu item link to prod dispatch
    const serverEnv = params.serverEnv || window.serverEnv;
    const hasJeppDispatch =
        !params?.currentUser?.isFF_FspAdmin &&
        hasJeppesenDispatch(params?.currentUser);

    let href;
    if (
        serverEnv === 'prod' &&
        window.location.host?.includes('beta') &&
        params?.currentUser.isBetaTeam
    ) {
        href = 'https://dispatch-beta.foreflight.com';
    } else {
        href = hasJeppDispatch
            ? params.urls.jeppDispatch
            : params.urls.dispatch;
    }
    return genericRender({
        name: 'Dispatch',
        href: href,
        icon: DispatchIconSvg,
        height: '16px',
        activeKey: 'prodispatch',
    });
};

export const renderJra = (params: RenderMenuParams) => {
    const hasJeppDispatch =
        !params?.currentUser?.isFF_FspAdmin &&
        hasJeppesenDispatch(params?.currentUser);

    const baseHref = hasJeppDispatch
        ? params.urls.jeppDispatch
        : params.urls.dispatch;
    const href = new URL('/jeppesen-rwa', baseHref).toString();

    return genericRender({
        name: 'Runway Analysis',
        href: href,
        icon: JraIcon,
        height: '16px',
        activeKey: 'jra',
    });
};

export const renderFleetTracking = (params: RenderMenuParams) => {
    //if we do the .bind pattern it will read window.serverEnv before renderMenu() has been called. This causes it
    // to not be set when loaded from dispatch qa, and so on dispatch qa the dispatch menu item link to prod dispatch
    return genericRender({
        name: 'Tracking',
        href: params.urls.tracking,
        icon: FleetTrackingIconSvg,
        height: '16px',
        activeKey: 'fleet_tracking',
    });
};

export const renderRecap = (showDivider: boolean) => {
    if (
        window.currentUser?.canSync &&
        isFeatureEnabled('logbook_recap') &&
        isFeatureEnabled('logbook_recap_menu_item') &&
        !hasJeppesenDispatch(window.currentUser) &&
        !isGovOrIl5EnvCommon(window.serverEnv)
    ) {
        const recap = genericRender({
            name: 'Recap 2025',
            url: 'recap',
            icon: CelebrationIconSvg,
            height: '15px',
            activeKey: 'recap',
        });
        recap.classList.add('recap');

        if (showDivider) {
            return [recap, renderDivider()];
        } else {
            return [recap];
        }
    }
};

export const renderDefaultRecap = () => {
    const el = renderRecap(true);
    // Recap is locked in place, but stays a valid drop target so its divider-bound
    // section can't become unreachable if every draggable item moves out of it.
    el?.forEach(e => e.classList.remove('ffmenu-draggable'));
    return el;
};

export const renderOrgRecap = () => {
    const el = renderRecap(false);
    el?.forEach(e => {
        e.style.marginBottom = '0';
    });
    return el;
};

export const renderFlights = ({ currentUser }: RenderMenuParams) => {
    const {
        dispatch_tools,
        isOrgFlightsAdmin,
        isEmployee,
        performance_planning,
        hasDispatchLowca,
    } = currentUser;

    if (
        (isFeatureEnabled('hide_flights_for_dispatch') && dispatch_tools) ||
        hasDispatchLowca ||
        hasCATrackingLicense(currentUser)
    )
        return null;

    const name =
        ((dispatch_tools && isOrgFlightsAdmin) || isEmployee) &&
        performance_planning
            ? 'My Flights'
            : 'Flights';

    return genericRender({
        name,
        url: 'flights',
        icon: FlightsIconSvg,
        height: '12px',
        activeKey: 'trips',
    });
};

export const renderMap = genericRender.bind(this, {
    name: 'Maps',
    url: 'map',
    icon: MapIconSvg,
    height: '15px',
    activeKey: 'map',
});

export const renderImagery = genericRender.bind(this, {
    name: 'Imagery',
    url: 'weather/imagery',
    icon: ImageryIconSvg,
    height: '15px',
    activeKey: 'imagery',
});

export const renderMarketplace = genericRender.bind(this, {
    name: 'Marketplace',
    url: 'marketplace',
    icon: MarketplaceIconSvg,
    height: '15px',
    activeKey: 'marketplace',
    gate: (c: CurrentUser) => !c?.isCorporate,
});

export const renderDocs = genericRender.bind(this, {
    name: 'Documents',
    url: 'documents',
    icon: DocsIconSvg,
    height: '14px',
    activeKey: 'documents',
});

export const renderCustomContent = (params: RenderMenuParams) => {
    if (!hasCustomContentMenuItem(params?.currentUser)) {
        return null;
    }
    const serverEnv = params.serverEnv || window.serverEnv;
    let href;
    if (
        serverEnv === 'prod' &&
        window.location.host?.includes('beta') &&
        params?.currentUser.isBetaTeam
    ) {
        href = 'https://dispatch-beta.foreflight.com/customcontent';
    } else {
        href = new URL('customcontent', params.urls.dispatch).toString();
    }

    return genericRender({
        name: 'Custom Content',
        href,
        icon: CustomContentIcon,
        height: '22px',
        activeKey: 'customcontent',
    });
};

export const renderAircraft = genericRender.bind(this, {
    name: 'Aircraft',
    url: 'aircraft',
    icon: AircraftIconSvg,
    height: '14px',
    activeKey: 'aircraft',
});

export const renderLogbook = genericRender.bind(this, {
    name: 'Logbook',
    url: 'logbook',
    icon: LogbookIconSvg,
    height: '13px',
    activeKey: 'logbook',
    gate: (c: CurrentUser) =>
        !hasJeppesenDispatch(c) && !hasCATrackingLicense(c),
});

export const renderLogbookCTA = (params: RenderMenuParams) => {
    if (
        params.isActive ||
        !params.featureFlags?.['logbook_for_life'] ||
        !window.location.href.includes('logbook')
    ) {
        return null;
    }

    return createLogbookCTA();
};

export const renderInsurance = genericRender.bind(this, {
    name: 'Insurance',
    url: 'insurance',
    icon: InsuranceIconSvg,
    height: '18px',
    activeKey: 'insurance',
    gate: (c: CurrentUser) =>
        hasInsurance(c) &&
        isFeatureEnabled('insurance') &&
        !isGovOrIl5EnvCommon(window.serverEnv),
});

export const renderDirectory = genericRender.bind(this, {
    name: 'Directory',
    url: 'directory',
    icon: DirectoryIconSvg,
    height: '15px',
    activeKey: 'directory',
});

export const renderTrackLogs = (params: RenderMenuParams) => {
    if (isFeatureEnabled('debrief_demo_page')) {
        return genericRender(
            {
                name: 'Track Logs',
                url: 'debrief',
                icon: TrackLogsIconSvg,
                height: '8px',
                activeKey: 'debrief',
                gate: (c: CurrentUser) =>
                    !hasJeppesenDispatch(c) && !hasCATrackingLicense(c),
            },
            params
        );
    } else {
        return genericRender(
            {
                name: 'Track Logs',
                url: 'tracklogs',
                icon: TrackLogsIconSvg,
                height: '8px',
                activeKey: 'tracklogs',
                gate: (c: CurrentUser) =>
                    !hasJeppesenDispatch(c) && !hasCATrackingLicense(c),
            },
            params
        );
    }
};

export const renderCloudAhoy = (params: RenderMenuParams) => {
    const { serverEnv } = params;
    let href;
    if (serverEnv === 'prod') {
        href = 'https://www.cloudahoy.com/fda';
    } else {
        href = 'http://carc.cloudahoy.com/fda';
    }
    return genericRender(
        {
            name: 'FDA',
            popUpText: 'Flight Data Analysis',
            href: href,
            icon: CloudAhoyIconSvg,
            height: '15px',
            activeKey: 'cloudahoy',
            gate: (c: CurrentUser) => c.isOrgOwner && c.cahoy_pfoqa,
        },
        params
    );
};

export const renderFleet = genericRender.bind(this, {
    name: 'Fleet',
    url: 'fleet',
    icon: FleetIcon,
    height: '15px',
    activeKey: 'fleet',
    gate: (c: CurrentUser) => c.isCorporate && c.isOrgAircraftAdmin,
});

export const renderPeople = genericRender.bind(this, {
    name: 'People',
    url: 'people',
    icon: PeopleIconSvg,
    height: '14px',
    activeKey: 'people',
    gate: () => isFeatureEnabled('people_web_tab'),
});

export const renderReservoir = genericRender.bind(this, {
    name: 'Reservoir',
    url: 'tfrs',
    icon: ReservoirIconSvg,
    height: '14px',
    activeKey: 'reservoir',
    gate: c => c.isDataTeam,
});

export const renderHoneywellForge = genericRender.bind(this, {
    name: 'Honeywell Forge',
    height: '20px',
    icon: HoneywellForgeIconSvg,
    href: 'https://bga.honeywellforge.com/ff',
    target: 'honewellForge',
    gate: (c: CurrentUser) => c.dispatch_tools && c.honeywell_forge_link,
});

export const renderRoster = genericRender.bind(this, {
    name: 'Roster',
    url: 'roster',
    icon: RosterIconSvg,
    height: '16px',
    activeKey: 'roster',
    gate: (c: CurrentUser) => c.hasRoster,
});

export const renderDataDownloads = ({
    currentUser,
    notifications,
}: RenderMenuParams) => {
    if (!currentUser.tethered_downloads) return;

    const el = genericRender({
        name: 'Data Downloads',
        url: 'downloads',
        icon: DataDownloadsIconSvg,
        height: '16px',
        activeKey: 'downloads',
    });
    if (
        !notifications ||
        !Object.prototype.hasOwnProperty.call(notifications, 'dataDownloads')
    ) {
        console.log(
            'Data download notification not found in notifications obj.'
        );
    } else if (notifications.dataDownloads)
        el.classList.add('new-notification');
    return el;
};

export const renderFSP = genericRender.bind(this, {
    name: 'Flight Services',
    url: 'flight-services',
    icon: FlightServicesIconSvg,
    height: '14px',
    activeKey: 'flight_services',
    gate: (c: CurrentUser) => c.isFspAdmin && c.flight_service_provider,
});

//genericRender.bind doesn't wait for the feature flags to be loaded
export const renderOrg = (params: RenderMenuParams) => {
    return genericRender(
        {
            name: 'Users',
            url: 'org/users',
            icon: OrgIconSvg,
            height: '12px',
            activeKey: 'users',
            gate: (c: CurrentUser) => c.isOrgUserAdmin && c.isCorporate,
        },
        params
    );
};

export const renderOrgSettings = genericRender.bind(this, {
    name: 'Settings',
    url: 'org-settings',
    icon: OrgSettingsIconSvg,
    height: '16px',
    activeKey: 'orgSettings',
    gate: (c: CurrentUser) => c.isOrgOwner && c.isCorporate,
});

export const renderSmartGroups = genericRender.bind(this, {
    name: 'Smart Groups',
    url: 'smartgroups',
    icon: IconSmartGroupsSvg,
    height: '12px',
    activeKey: 'smartGroups',
    gate: () => hasSmartGroups() && (isOrgOwner() || isGroupOwner()),
});

export const renderBilling = genericRender.bind(this, {
    name: 'Billing',
    url: 'org/billing/renewals',
    icon: IconBillingSvg,
    height: '18px',
    activeKey: 'billing',
    gate: (c: CurrentUser) =>
        shouldShowBilling(c) &&
        !hasJeppesenDispatch(c) &&
        !hasCATrackingLicense(c),
});

export const renderEnterpriseDocuments = genericRender.bind(this, {
    name: 'Docs Manager',
    url: 'enterprise-documents',
    icon: ManageDocsIconSvg,
    height: '14px',
    activeKey: 'enterprise-documents',
    gate: (c: CurrentUser) =>
        hasEnterpriseDocuments() &&
        (isFeatureEnabled('enterprise_documents_sub_org')
            ? isOrgOwner() || isSubOrgAdmin()
            : isOrgOwner()),
});

export const renderJetFuelX =
    (locked = true) =>
    (params: RenderMenuParams) => {
        const { serverEnv } = params;
        let href;
        if (serverEnv === 'prod') {
            href = 'https://fuel.foreflight.com/';
        } else {
            href = 'http://fuel.acqa.foreflight.com/';
        }
        const el = genericRender(
            {
                name: 'JetFuelX',
                href: href,
                icon: JetFuelXIconSvg,
                height: '16px',
                activeKey: 'jetfuelx',
                gate: (c: CurrentUser) =>
                    !hasCATrackingLicense(c) || hasJeppesenDispatch(c),
            },
            params
        );
        //JetFuelX is in is own set of divders. (Sometimes alone, sometimes not).
        // To prevent those two dividers from being "empty" we lock jetfulex to have to
        // stay there, but it remains a valid drop target (see AddItems/ReorderMode.ts).
        if (locked) el?.classList.remove('ffmenu-draggable');
        return el;
    };

export const renderAccount = ({ currentUser }: RenderMenuParams) => {
    const el = genericRender({
        name: currentUser.prettyName2 || 'Account',
        url: 'account',
        icon: AccountIconSvg,
        height: '14px',
        activeKey: 'account',
    });
    el.classList.remove('ffmenu-draggable', 'ffmenu-droppable');
    return el;
};

export const renderGetHelp = (params: RenderMenuParams) => {
    const hasJeppDispatch = params?.currentUser?.hasDispatchLowca;
    const el = genericRender({
        name: 'Still Need Help?',
        height: '18px',
        icon: GetHelpIconSvg,
        href: hasJeppDispatch
            ? 'https://support.jeppesen.com/product?pc=Flight_Planning&pid=Jeppesen_Dispatch'
            : 'http://foreflight.com/support/enterprise-portal',
        target: 'gethelp',
    });
    el.setAttribute('id', 'get_help');
    el.classList.remove('ffmenu-draggable', 'ffmenu-droppable');
    return el;
};

export const renderSupport = () => {
    const el = genericRender({
        name: 'Learn & Solve',
        height: '18px',
        icon: SupportIconSvg,
        href: window.location.href.includes('dispatch')
            ? 'https://foreflight.com/support/dispatch-guide'
            : 'https://foreflight.com/support',
        target: window.location.href.includes('dispatch')
            ? 'dispatch_guide'
            : 'support',
    });
    el.setAttribute('id', 'support');
    el.classList.remove('ffmenu-draggable', 'ffmenu-droppable');
    return el;
};

export const renderChecklist = genericRender.bind(this, {
    name: 'Checklist',
    url: 'checklist',
    icon: ChecklistIconSvg,
    height: '16px',
    activeKey: 'checklist',
    gate: (c: CurrentUser) => isFeatureEnabled('checklist_on_web'),
});

export const renderLogout = (params: RenderMenuParams) => {
    const serverEnv = params?.serverEnv || window?.serverEnv;
    const next = hasJeppesenDispatch(params?.currentUser)
        ? `?next=/?next=https://jeppesendispatch${
              serverEnv === 'qa' ? '.qa' : ''
          }.foreflight.com/`
        : '';

    const el = genericRender({
        name: 'Logout',
        url: `auth/api/logout${next}`,
        icon: LogoutIconSvg,
        height: '14px',
    });
    el.addEventListener('click', () => {
        //remove saved collapse state when logging out
        Object.keys(localStorage)
            .filter(d => d.includes('sub-section-collapse'))
            .forEach(k => {
                localStorage.removeItem(k);
            });
        sessionStorage.removeItem('hideMilitaryAdPopUpSession');
        sessionStorage.removeItem('hideUserAppMilitaryAdBanner');
        sessionStorage.removeItem(GET_MENU_ORDER_LOCAL_STORAGE_KEY(params));
    });
    el.classList.remove('ffmenu-draggable', 'ffmenu-droppable');
    return el;
};

export const renderSubsectionHeader = (name: string) => {
    const el = genericRender({
        name,
        icon: Chevron,
        height: '10px',
        href: '', //its a required prop, but we remove it bc we dont need it
    });
    el.classList.add('sub-section-header');
    el.classList.remove('ffmenu-draggable', 'ffmenu-droppable');
    el.removeAttribute('href');
    return el;
};

export const renderFlightScheduler = genericRender.bind(this, {
    name: 'Schedule',
    url: 'flight-scheduler',
    icon: FlightSchedulerIcon,
    height: '18px',
    activeKey: 'flight_scheduler',
    gate: (c: CurrentUser) =>
        isFeatureEnabled('flight_scheduler') &&
        !isGovOrIl5EnvCommon(window.serverEnv),
});

export const renderJourneyLog = genericRender.bind(this, {
    name: 'Journey Log',
    url: 'activenavlog',
    icon: LogbookIconSvg,
    height: '16px',
    activeKey: 'activenavlog',
    gate: () =>
        isFeatureEnabled('journey_log') &&
        hasLicense('journey_log') &&
        (isOrgDocumentsAdmin() || isOrgOwner()),
});

export const renderSafetyManagementSystems = genericRender.bind(this, {
    name: 'Safety',
    url: 'sms',
    icon: FratShieldIcon,
    height: '18px',
    activeKey: 'sms',
    gate: (c: CurrentUser) =>
        (isFeatureEnabled('sms') && hasSmsLicense()) ||
        (hasFratLicense() && c.isSafetyManager),
});

export const renderTripPlanner = (params: RenderMenuParams) => {
    const serverEnv = params.serverEnv || window.serverEnv;
    let href;
    if (serverEnv === 'prod') {
        href = 'https://planner.foreflight.com';
    } else {
        // Default to the QA/non-prod Trip Planner host
        href = 'https://planner.qa.foreflight.com';
    }
    const element = genericRender(
        {
            name: 'Trip Planner',
            href,
            icon: TripPlannerIcon,
            height: '18px',
            activeKey: 'trip_planner',
            gate: (currentUser: CurrentUser) =>
                isFeatureEnabled('trip_planner') && hasTripPlanner(currentUser),
        },
        params
    );
    return element;
};

export const renderAirportDirectory = (params: RenderMenuParams) => {
    const serverEnv = params.serverEnv || window.serverEnv;
    let href;
    if (
        serverEnv === 'prod' &&
        window.location.host?.includes('beta') &&
        params?.currentUser.isBetaTeam
    ) {
        href = 'https://dispatch-beta.foreflight.com/recent-airports';
    } else {
        href = params.urls.dispatch + '/recent-airports';
    }

    return genericRender(
        {
            name: 'Airports',
            href: href,
            icon: AirportDirectoryIcon,
            height: '16px',
            activeKey: 'airports',
            gate: (c: CurrentUser) => hasDispatchTools(c) || isAllTiers(c),
        },
        params
    );
};

/********* Generic render section. ***************************/
// region Parameter Interfaces
interface IGenericRender {
    name: string;
    icon: string;
    height: string;
    activeKey?: string;
    target?: string;
    testId?: string;
    gate?: (c: CurrentUser) => boolean;
    popUpText?: string;
}

interface UrlGenericRender extends IGenericRender {
    url: string;
}
interface HrefGenericRender extends IGenericRender {
    href: string;
}
//endregion
//region Typeguards
const isUrlGenericRender = (
    params: UrlGenericRender | HrefGenericRender
): params is UrlGenericRender => {
    return !!(params as UrlGenericRender).url;
};
//endregion

function genericRender(
    params: UrlGenericRender | HrefGenericRender,
    renderParams?: RenderMenuParams
): HTMLAnchorElement | undefined {
    const {
        name,
        icon,
        height,
        activeKey,
        gate,
        target,
        testId,
        popUpText,
        ...rest
    } = params;
    if (gate && !gate(renderParams?.currentUser)) {
        return;
    }
    // Centralized environment-based visibility (e.g. items hidden in gov/il5).
    // See hiddenMenuItems.ts. Runs after the item's own gate so gates still win.
    if (
        isMenuItemHiddenForEnv(
            activeKey,
            renderParams?.serverEnv || window.serverEnv
        )
    ) {
        return;
    }
    //Some menu items don't have a activeKey (Logout, Support for example). If the menu is rendered with activeMenu not set
    // (aka its set to undefined) then activeKey DOES equal activeMenu. So we check if activeKey is defined first to determine
    // if isActive should be true or not.
    const isActive = activeKey && window.activeMenu === activeKey;
    const el = document.createElement('a');
    el.classList.add('ffmenu-item');
    // Items are fully reorderable by default; specific render functions opt out by
    // removing one or both of these classes (see AddItems/ReorderMode.ts).
    el.classList.add('ffmenu-draggable', 'ffmenu-droppable');
    if (isActive) el.classList.add('active');
    if (isUrlGenericRender(params))
        el.setAttribute('href', `${host}/${params.url}`);
    else el.setAttribute('href', `${params.href}`);

    logClick(el, `${activeKey === 'account' ? 'Account' : name} Tab Clicked`, {
        eventSourcePage: 'Navigation Bar',
    });

    if (target) {
        el.setAttribute('target', target);
    }

    if (icon) {
        const img = document.createElement('img');
        img.setAttribute('src', icon);
        img.style.height = height;
        el.appendChild(img);
    }

    // add test-id: it will use testId if provided, otherwise use the lowercase version of the menu name and replace any space with '-'
    // ex. if name is Custom Content, then the test id will be 'data-testid="ffmenu-custom-content"'
    const ffmenuTestId =
        testId || `ffmenu-${name.replace(/\s+/g, '-').toLowerCase()}`;
    el.setAttribute('data-testid', ffmenuTestId);

    // Stable identifier for this menu item, independent of the (test-focused) data-testid above.
    // Used to identify items for reorder/persistence purposes.
    const menuItemId = activeKey || name.replace(/\s+/g, '-').toLowerCase();
    el.setAttribute('data-menu-item-id', menuItemId);

    const text = document.createElement('span');
    text.style.textOverflow = 'ellipsis';
    text.style.overflow = 'hidden';
    text.innerText = name;
    if (popUpText) text.setAttribute('data-popup-name', popUpText);
    el.appendChild(text);

    return el;
}

export function shouldShowBilling(c?: CurrentUser) {
    const currentUser = c || window.currentUser || {};
    return (
        currentUser?.isOrgBillingAdmin &&
        currentUser?.isCorporate &&
        !hasLicense('reseller_customer')
    );
}
